<template>
  <div>
    <v-navigation-drawer
      v-if="!$route.meta.fullScreenMap"
      v-model="sideNav"
      app
      :permanent="!$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      fixed
      width="240px"
      class="fixedSidebar"
    >
      <div class="sidebar-header">
        <v-img contain width="38px" height="38px" src="../assets/sarpamp.png" class="sidebar-logo-img mr-2"></v-img>
        <span class="sidebar-title">SARPA <span class="accent-text">MP</span></span>
      </div>

      <div class="sidebar-scroll-container" @scroll="handleSidebarScroll">
        <v-list dense nav class="px-2 pt-4">
          <template v-for="item in filteredDashboard">
            
            <!-- IF THE ITEM HAS CHILDREN (DROPDOWN GROUP) -->
            <v-list-group
              v-if="item.children"
              :key="'group-' + item.title"
              color="#de520c"
              class="nav-group mb-2"
            >
              <!-- Activator template for the parent button -->
              <template v-slot:activator>
                <v-list-item-icon class="mr-3 my-0 align-self-center">
                  <v-icon class="nav-icon">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- Child items revealed when clicking parent -->
              <v-list-item
                v-for="subItem in item.children"
                :key="subItem.title"
                :to="subItem.path"
                link
                class="mb-1"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="18">{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 13.5px; font-family: poppinsmedium">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <!-- IF THE ITEM IS A SINGLE LINK -->
             <v-list-item
              v-else
              :key="'item-' + item.title"
              :to="item.path"
              link
              class="nav-item mb-2"
              active-class="active-nav-item"
              :class="{ 'active-nav-item': isRescuerGroup(item.path) }"
            >

              <v-list-item-icon class="mr-3">
                <v-icon class="nav-icon">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div class="sidebar-footer-image"></div>
    </v-navigation-drawer>
    <v-layout wrap fill-height>
      <v-flex :class="!$route.meta.fullScreenMap ? 'main-content-flex' : 'fullscreen-flex'">
        <v-layout wrap pb-0 mb-0 v-if="!$route.meta.fullScreenMap" style="position: sticky; top: 0; z-index: 100;">
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
        </v-layout>
          <v-flex xs12 sm12 md12 lg12 pl-0 v-if="!$route.meta.fullScreenMap">
            <v-layout wrap justify-center :style="$route.name == 'adminDashboard'
              ? 'background-color: #F5F6FA'
              : 'background-color: #fff6f2'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <div v-else class="fullscreen-router-container">
            <router-view :key="$route.fullPath"></router-view>
          </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import SarpaAppHeader from "@/components/Common/appHeadersarpa";

export default {
  components: {
    SarpaAppHeader,
  },
  data() {
    return {
      sarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        // {
        //   title: "Statistics ",
        //   icon: "mdi-chart-bar",
        //   path: "/admin/commonanalyticspage",
        // },
        // {
        //   title: "Add Snakes",
        //   icon: "mdi-snake",
        //   path: "/addSnakes",
        // },
        {
          title: "Snakes",
          icon: "mdi-format-list-bulleted",
          path: "/listedSnakes",
        },
        {
          title: "All Users",
          icon: "mdi-account-group",
          path: "/usersList",
        },
        // {
        //   title: "DFO List",
        //   icon: "mdi-account-details",
        //   path: "/dfoList",
        // },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/controlRoomList",
        },
        {
          title: "Rescuers",
          icon: "mdi-account-group",
          path: "/newrescuerslist",
        },
       
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/alldmolist",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/alldistrictlist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/approvedoperations",
        // },
        // {
        //   title: "Delete Operations",
        //   icon: "mdi-delete-sweep",
        //   path: "/deleteoperations",
        // },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline ",
          path: "/snakeBite",
        },


        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/fraudcases",
        // },



        {
          title: "Resources",
          icon: "mdi-folder-multiple-image",
          path: "/resources",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/snakereports",
        },
        // {
        //   title: "Add Snake Experts",
        //   icon: "mdi-plus",
        //   path: "/addsnakeexperts",
        // },
        {
          title: "Hospitals",
          icon: "mdi-hospital-building",
          path: "/Viewhospital",
        },
        {
          title: "Venom Details",
          icon: "mdi-hospital",
          path: "/listVenom",
        },
        {
          title: "Victim Details",
          icon: "mdi-hospital-box",
          path: "/victimDetails",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-box-multiple-outline",
          path: "/identificationhelp",
        },
        {
          title: "Reports",
          icon: "mdi-file-excel",
          path: "/excelreport",
        },
          {
          title: "All Maps",
          icon: "mdi-map",
          path: "/allMap",
        },
        {
          title: "About Us",
          icon: "mdi-information-outline",
          path: "/about-us",
        },
         {
          title: "Back Story",
          icon: "mdi-account-question",
          path: "/back-story",
        }
        ,{
          title: 'Mission and Vision',
          icon: 'mdi-eye',
          path: "/mission-and-vision",
        },
        {
          title: "Privacy Policy",
          icon: "mdi-lock-outline",
          path: "/privacy-policy",
        },
        {
          title: "Terms & Conditions",
          icon: "mdi-information-outline",
          path: "/terms-and-conditions",
        }

      ],
      right: null,
      showExcel: false,
    };
  },
  computed: {
    sideNav: {
      get() {
        return this.$store.state.sideNavOpen;
      },
      set(val) {
        this.$store.commit('setSideNav', val);
      }
    },
    filteredDashboard() {
      if (this.showExcel) {
        return this.sarpadashboard;
      }
      return this.sarpadashboard.filter((item) => item.title !== "Excel");
    },
  },
  watch: {
    $route() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$store.commit('setSideNav', false);
      }
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    isRescuerGroup(path) {
      if (path === '/newrescuerslist') {
        const rescuerRoutes = ['newrescuerslist', 'newrescuerslistcircle', 'allrescuerlist', 'bannedRescuers', 'traininglist', 'ratingsList'];
        return rescuerRoutes.includes(this.$route.name);
      }
      return false;
    },
    handleSidebarScroll(event) {
      if (event.target.scrollTop > 0) {
        this.showExcel = true;
      } else {
        this.showExcel = false;
      }
    }
  }
};
</script>
<style scoped>
.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 240px) !important;
    width: calc(100% - 240px) !important;
    margin-left: 240px !important;
  }
}

.fullscreen-flex {
  width: 100% !important;
  margin-left: 0 !important;
  display: flex;
  flex-direction: column;
}

.fullscreen-router-container {
  flex: 1 1 auto;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}
  /* Sidebar background */
.fixedSidebar {
  background-color: #feebdb !important; /* synced with mountain image background */
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.04) !important;
  border-right: 1px solid #f0f0f0 !important;
  z-index: 1000 !important;
}

/* Use flex layout to cleanly separate scrollable list from pinned footer */
::v-deep .v-navigation-drawer__content {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important; /* using relative units vh instead of just % */
  overflow: hidden !important; 
}

.sidebar-scroll-container {
  height: calc(100vh - 68px); /* Full remaining height */
  max-height: calc(100vh - 68px);
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  z-index: 1; /* Ensure it stays above the background if needed */
}

.sidebar-footer-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 200px; /* Restore full uncropped height */
  background-image: url("../assets/sidebar_footer.jpg");
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 0;
  pointer-events: none; /* Doesn't block clicks */
}



/* Custom scrollbar for the nav list container */
.sidebar-scroll-container::-webkit-scrollbar {
  width: 8px !important;
}
.sidebar-scroll-container::-webkit-scrollbar-track {
  margin-bottom: 200px; /* Shorten scrollbar track so it doesn't overlap footer */
}
.sidebar-scroll-container::-webkit-scrollbar-thumb {
  background: #de520c !important;
  border-radius: 4px;
}

/* Make list not individually scrollable, let container handle it */
.fixedSidebar ::v-deep .v-list {
  background: transparent !important;
  flex: 0 0 auto !important;
  padding-bottom: 100px !important;
  padding-top: 8px !important;
}

.sidebar-header {
  background: #feebdb !important; /* Sync background color to the rest of the sidebar */
  height: 68px !important;
  min-height: 68px !important;
  max-height: 68px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 22px !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
}

.sidebar-logo-img {
  max-height: 38px !important;
  max-width: 38px !important;
  flex-shrink: 0;
}

.sidebar-title {
  font-family: "poppinsmedium", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  letter-spacing: 0.5px;
}

.sidebar-title .accent-text {
  color: #ff7a00;
}

/* Compact Menu Items Reset */
.nav-item {
  position: relative;
  border-radius: 6px !important;
  margin: 1px 10px !important; /* Tighter gap */
  padding: 0 12px !important;
  min-height: 32px !important; /* Reduced row height */
  transition: all 0.2s ease !important;
  display: flex;
  align-items: center;

}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-icon {
  color: #de520c !important; 
  font-size: 18px !important;
}

.nav-title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12.5px !important;
}

.nav-item:hover .nav-icon {
  color: #de520c !important;
}

.nav-item:hover .nav-title {
  color: #000000 !important;
  font-weight: 600 !important;
}

/* Active State Pill */
.active-nav-item {
  background: #de520c !important;
  box-shadow: 0 4px 10px rgba(222, 82, 12, 0.3) !important;
}

.active-nav-item .nav-icon {
  color: #ffffff !important;
}

.active-nav-item .nav-title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Dropdown Parent */
.nav-group ::v-deep .v-list-group__header {
  border-radius: 6px !important;
  margin: 1px 10px !important;
  padding: 0 12px !important;
  min-height: 32px !important;
  transition: all 0.2s ease !important;

}

.nav-group ::v-deep .v-list-group__header:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-group ::v-deep .v-list-group__header .v-list-item__icon .v-icon,
.nav-group ::v-deep .v-list-group__header .nav-icon {
  color: #de520c !important;
  font-size: 18px !important;
}

.nav-group ::v-deep .v-list-group__header .nav-title,
.nav-group ::v-deep .v-list-group__header .v-list-item__title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12.5px !important;
}

.nav-group ::v-deep .v-list-group__header:hover .v-list-item__icon .v-icon,
.nav-group ::v-deep .v-list-group__header:hover .nav-icon {
  color: #de520c !important;
}

.nav-group ::v-deep .v-list-group__header:hover .nav-title,
.nav-group ::v-deep .v-list-group__header:hover .v-list-item__title {
  color: #000000 !important;
  font-weight: 600 !important;
}

/* Dropdown Active/Expanded */
.nav-group ::v-deep .v-list-group__header.v-list-item--active {
  background: #de520c !important;
  box-shadow: 0 4px 10px rgba(222, 82, 12, 0.3) !important;
}

.nav-group ::v-deep .v-list-group__header.v-list-item--active .v-list-item__icon .v-icon,
.nav-group ::v-deep .v-list-group__header.v-list-item--active .nav-icon {
  color: #ffffff !important;
}

.nav-group ::v-deep .v-list-group__header.v-list-item--active .nav-title,
.nav-group ::v-deep .v-list-group__header.v-list-item--active .v-list-item__title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Dropdown Children */
.nav-group ::v-deep .v-list-group__items .v-list-item {
  border-radius: 6px !important;
  margin: 1px 10px 1px 24px !important;
  padding: 0 12px !important;
  min-height: 30px !important; /* Slightly smaller for children */
  transition: all 0.2s ease !important;

}

.nav-group ::v-deep .v-list-group__items .v-list-item .v-icon {
  color: #de520c !important;
  font-size: 16px !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item .v-list-item__title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-group ::v-deep .v-list-group__items .v-list-item:hover .v-icon {
  color: #de520c !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item:hover .v-list-item__title {
  color: #000000 !important;
  font-weight: 600 !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active {
  background: #de520c !important;
  box-shadow: 0 2px 6px rgba(222, 82, 12, 0.3) !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active .v-icon {
  color: #ffffff !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active .v-list-item__title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

</style>
